export const ActionType = {

    LOGIN: "LOGIN",
    MASTER_LOGIN: "MASTER_LOGIN",
    ADAY_LOGIN: "ADAY_LOGIN",
    LOGOUT: "LOGOUT",

    ADD_NOTIFICATION: "ADD_NOTIFICATION",
    REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",

    CHANGE_LANG: "CHANGE_LANG",
    SET_PINNED: "SET_PINNED",
    LOAD_ICONS: 'LOAD_ICONS',
    LOAD_ICONS_ERROR: 'LOAD_ICONS_ERROR',

    ADD_LIST: "ADD_LIST",      // Action type for adding a list of items
    REMOVE_LIST: "REMOVE_LIST", // Action type for removing a list of items by ids
    GET_LIST: "GET_LIST",       // Action type for getting the current list (used for debugging)

};
